/**
 * ApiKeySection — F-B.7
 *
 * Zeigt den API-Schlüssel des Benutzers in den Einstellungen.
 * Maskiert standardmäßig, mit Toggle zum Anzeigen und Kopier-Button.
 *
 * R3-S3: Die Feld-Darstellung liegt jetzt in components/ApiKeyField.tsx und
 * wird vom Developer-Bereich (API-Doku) mitbenutzt.
 */
import { useTranslation } from 'react-i18next'
import { Link } from '@tanstack/react-router'
import { ApiKeyField } from '../../components/ApiKeyField'

type Props = {
  apiKey?: string | null
  /** Optional vorberechnete Maske aus dem Backend (api_key_masked). */
  apiKeyMasked?: string | null
  /** account.api_access — Free-User haben laut Contract keinen API-Zugang. */
  apiAccess?: boolean
}

export function ApiKeySection({ apiKey, apiKeyMasked, apiAccess }: Props) {
  const { t } = useTranslation('settings')

  const hasKey = apiKey != null && apiKey.length > 0

  return (
    <div className="card card-pad" data-testid="api-key-section" style={{ marginBottom: 18 }}>
      <h3 style={{ marginBottom: 14 }}>{t('apiKey.title')}</h3>

      {apiAccess === false ? (
        // Review-Fix: bei fehlendem API-Zugang KEINEN Key/Kopierfunktion
        // zeigen (Contract sagt fuer Free-Tarife oft trotzdem einen Key
        // voraus) — nur der Hinweis.
        <p className="muted" data-testid="api-key-premium-hint" style={{ fontSize: 13, margin: 0 }}>
          {t('apiKey.premiumHint')}{' '}
          <Link to="/plans">{t('components:premiumRequired.upgrade')}</Link>
        </p>
      ) : !hasKey ? (
        <p className="muted" style={{ fontSize: 13, margin: 0 }}>
          {t('apiKey.noKey')}
        </p>
      ) : (
        <ApiKeyField
          apiKey={apiKey}
          maskedValue={apiKeyMasked}
          testIdPrefix="api-key"
          labels={{
            ariaLabel: t('apiKey.ariaLabel'),
            show: t('apiKey.show'),
            hide: t('apiKey.hide'),
            showAria: t('apiKey.showAria'),
            hideAria: t('apiKey.hideAria'),
            copy: t('apiKey.copy'),
            copyAria: t('apiKey.copyAria'),
          }}
        />
      )}
    </div>
  )
}
